function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function isConfigObject(value) {
  return !!value && _typeof(value) === 'object' && !Array.isArray(value);
}
function missingFields(config) {
  var missing = [];
  if (!String(config.host || '').trim()) {
    missing.push('host');
  }
  if (!isConfigObject(config.auth) || !String(config.auth.user || '').trim()) {
    missing.push('auth.user');
  }
  if (!isConfigObject(config.auth) || !String(config.auth.pass || '').trim()) {
    missing.push('auth.pass');
  }
  return missing;
}
function parseSendgridConfig(raw) {
  var parsed = raw;
  if (typeof raw === 'string') {
    try {
      parsed = JSON.parse(raw.trim());
    } catch (err) {
      throw new Error('SendGrid configuration is not valid JSON');
    }
  }
  if (!isConfigObject(parsed)) {
    throw new Error('SendGrid configuration must be a JSON object');
  }
  var missing = missingFields(parsed);
  if (missing.length) {
    throw new Error("SendGrid configuration is incomplete (missing: ".concat(missing.join(', '), ")"));
  }
  return {
    host: String(parsed.host).trim(),
    port: parsed.port == null || parsed.port === '' ? 465 : Number(parsed.port),
    secure: parsed.secure !== false,
    auth: {
      user: String(parsed.auth.user).trim(),
      pass: String(parsed.auth.pass)
    }
  };
}
function resolveSendgridTransport(envValue) {
  var _options$sendgrid;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (envValue && String(envValue).trim()) {
    return {
      source: 'environment',
      config: parseSendgridConfig(envValue)
    };
  }
  var stored = options === null || options === void 0 || (_options$sendgrid = options.sendgrid) === null || _options$sendgrid === void 0 ? void 0 : _options$sendgrid.config;
  if (typeof stored === 'string' && stored.trim()) {
    return {
      source: 'wallet',
      config: parseSendgridConfig(stored)
    };
  }
  if (isConfigObject(stored)) {
    return {
      source: 'wallet',
      config: parseSendgridConfig(stored)
    };
  }
  return null;
}
function redactSendgridConfig(config) {
  var copy = parseSendgridConfig(config);
  copy.auth.pass = copy.auth.pass ? '••••••••' : '';
  return copy;
}
module.exports = {
  parseSendgridConfig: parseSendgridConfig,
  resolveSendgridTransport: resolveSendgridTransport,
  redactSendgridConfig: redactSendgridConfig
};